export default __webpack_public_path__ + "/dist/images/category.4c4b83762c5806d3d00601f40328aadd.svg";